import React from 'react';
import { components } from 'react-select';
import ColorConstants from '../../../shared/constants/ColorConstants';

export const SelectControl = ({
    innerProps,
    selectProps,
    ...props
}) => (
    <components.Control
        {...props}
        selectProps={selectProps}
        innerProps={{
            ...innerProps,
            'data-testid': selectProps?.testIds?.Control,
        }}
    />
);

export const SelectControlStyles = styles => ({
    ...styles,
    minHeight: '52px',
    background: 'transparent',
    borderColor: ColorConstants['catskill-white'],
    boxShadow: '#0000001A',
    '&:hover': {},
});
